import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, ListGroupItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import { parse, distanceInWordsStrict, format } from 'date-fns';
import { MatchStatus } from '~/utils/const/identity';
import DataPoint from './DataPoint';

const PatientMatchingItem = ({ data }) => {
  const matchStatusId = data.attributes.matchStatusId || MatchStatus.Unmatched;

  return (
    <ListGroupItem
      className="border-left-0 border-right-0"
      action
      tag={Link}
      to={`/admin/identity-matches/identity-disputes/${matchStatusId}/${data.attributes.sacwisPersonId}`}
    >
      <Row>
        <Col>
          <DataPoint
            label={`${data.attributes.lastName}, ${data.attributes.firstName}`}
          />

          <DataPoint
            label="Age"
            value={distanceInWordsStrict(parse(data.attributes.birthDate), new Date(), {
              unit: 'Y',
            })}
          />

          <DataPoint
            value={data.attributes.gender}
          />

          <DataPoint
            label="Alias"
            value={data.attributes.alias1}
          />

          <DataPoint
            label={`${data.attributes.matchStatusId === MatchStatus.Disputed ? 'Disputed' : 'Match Status'} Date`}
            value={data.attributes.matchStatusDate ? format(data.attributes.matchStatusDate, 'MM/DD/YYYY') : ''}
          />

          <DataPoint
            label="Data Source"
            value={data.attributes.sourceDescription}
          />
        </Col>

        <Col>
          <DataPoint
            label="Date of birth"
            value={format(data.attributes.birthDate, 'MM/DD/YYYY')}
          />

          <DataPoint
            label="Person ID"
            value={data.attributes.sacwisPersonId}
          />

          <DataPoint
            label="County"
            value={data.attributes.county || data.attributes.agencyCounty}
          />

          <DataPoint
            label="Case ID"
            value={data.attributes.caseId}
          />

          <DataPoint
            label="Race"
            value={data.attributes.race}
          />

          <DataPoint
            label="Ethnicity"
            value={data.attributes.ethnicity}
          />
        </Col>
      </Row>
    </ListGroupItem>
  );
};

PatientMatchingItem.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default PatientMatchingItem;
